import PromineoGridDropdown from "../../../components/common/controls/PromineoGridDropdown";
import { ContactRequestStatus } from "../../../shared/enums/ContactRequestStatusEnum";
import { GetEnumKeyValues } from "../../../shared/utility/CommonUtility";
import ContactSales from "../../../interfaces/response/ContactSales";

interface Props {
  selectedRow: ContactSales;
  onValueChange: (selectedRowId: number, selectedOption: number) => void;
}

export default function StatusSelector(props: Props) {
  const { selectedRow, onValueChange } = props;
  const contactRequestStatusValues = GetEnumKeyValues(ContactRequestStatus);
  const statusOptions = [
    ...contactRequestStatusValues.map((keyVal: { key: string; value: number }) => ({
      value: keyVal.value,
      display: keyVal.key,
    })),
  ];

  const handleSelectionChange = (data: any) => {
    onValueChange(selectedRow.id, data.value);
  };

  return (
    <PromineoGridDropdown
      items={statusOptions}
      onValueChanged={handleSelectionChange}
      className="w-44"
      defaultValue={selectedRow.status}
      displayExpr="display"
      valueExpr="value"
    />
  );
}